import { runFingerprintProFlow } from "@/utils/fingerprintPro"

export const useFetchFingerprintPro = () => {
  const authStore = useAuthStore()
  const { userID } = storeToRefs(authStore)

  // The account keys the Enterprise "already recorded" flag in localStorage.
  // It can still be empty when App.vue tracks an API white-label session on
  // mount; the flow then sends isExisted=false and the backend decides.
  const fetchFingerprintPro = () => runFingerprintProFlow(userID.value || undefined)

  return {
    fetchFingerprintPro
  }
}

export default useFetchFingerprintPro
